import { FilterState } from "./filters";

export const getLabelFilterKeyAndValue = (id: string) => {
  // Could be multiple colons in the value, so we need to find the first one
  const idx = id.indexOf(":");
  const key = id.slice(0, idx);
  const value = id.slice(idx + 1);

  return { key, value };
};

export const isFilterActive = (
  filter: FilterState | undefined,
): filter is FilterState =>
  Boolean(filter && !filter.isAllSelected && filter.selected.length);

export const labelFilter = (state: FilterState | undefined) => {
  if (isFilterActive(state)) {
    return {
      _or: state.selected.map((filter) => {
        if (filter.id === "-1") {
          return {
            tags: { _eq: {} },
          };
        }

        const { key, value } = getLabelFilterKeyAndValue(filter.id);

        const obj = {};
        obj[key!] = value;
        return {
          tags: { _contains: obj },
        };
      }),
    };
  }
  return {};
};

export const segmentLabelFilter = (state: FilterState | undefined) => {
  const baseFilter = labelFilter(state);

  return baseFilter._or
    ? { _or: baseFilter._or.map(({ tags }) => ({ segment: { tags } })) }
    : {};
};

export const createdFilter = (state: FilterState | undefined) => {
  if (isFilterActive(state)) {
    return {
      created_by: { _in: state.selected.map((f) => f.id) },
    };
  }
  return {};
};
